import Vue from 'vue'
import VueRouter from 'vue-router'
import Score from '@/pages/survey/Score'
import Reason from '@/pages/survey/Reason'
import Advice from '@/pages/survey/Advice'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/survey_personal_center',
      redirect: '/survey_personal_center/score',
    },
    {
      path: '/',
      redirect: '/survey_personal_center/score',
    },
    {
      path: '/survey_personal_center/score',
      name: 'Score',
      component: Score,
    },
    {
      path: '/survey_personal_center/reason',
      name: 'Reason',
      component: Reason,
    },
    {
      path: '/survey_personal_center/advice',
      name: 'Advice',
      component: Advice,
    },
  ],
})
